module.exports = __webpack_public_path__ + "img/PlanQ-Logo-Square.42af7c9f.png";